import axios from 'axios';

const actions = {
  getQuotes({ commit }, payload) {
    const url = `${process.env.VUE_APP_SERVER_URL}/user/${payload}/quotes`;
    return axios.get(url)
      .then((response) => {
        const quotes = response.data;
        commit('setQuotes', quotes);
      });
  },
  getAllQuotes({ commit }) {
    const url = `${process.env.VUE_APP_SERVER_URL}/quotes`;
    return axios.get(url)
      .then((response) => {
        const quotes = response.data;
        commit('setQuotes', quotes);
      });
  },
  createQuote({ dispatch }, payload) {
    const url = `${process.env.VUE_APP_SERVER_URL}/user/${payload.id}/quotes`;
    return axios.post(url, payload.data)
      .then(() => {
        dispatch('getQuotes', payload.userId);
      });
  },
};

const mutations = {
  setQuotes(state, quotes) {
    state.quotes = quotes;
  },
};

const state = {
  quotes: {},
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
